
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.942 5h-3.2l2.841 4.407L14.573 5H11.37l2.844 5.775L8.204 5H5l2.796 7.454L5 27h3.204l6.008-15.597L11.37 27h3.202l6.011-16.964L17.741 27h3.2L27 8.367 20.942 5z","fill":"#fff"}})])
          )
        }
      }
    